import React, { Component } from 'react'

export default class SideContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: this.calcHeight(),
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.setHeight)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.setHeight)
    }
  }

  setHeight = () => this.setState({ height: this.calcHeight() })

  calcHeight = () =>
    typeof window !== 'undefined'
      ? window.innerHeight - (this.props.minusHeight || 0)
      : 600

  render() {
    const { fixedHeight, minusHeight, style, children, ...rest } = this.props
    const containerStyle = {
      ...style,
    }
    if (fixedHeight) {
      containerStyle.height = this.state.height
    } else {
      containerStyle.minHeight = this.state.height
    }
    return (
      <div className={ "scrollable" } style={containerStyle} {...rest}>
        {children}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/shared/sideContainer.js